<div class="w-full h-full relative">
    @if (loading()) {
        <div data-testid="iq-ntl-graph-multi-loader" class="w-full h-full absolute inset-0 bg-dat-grey-200 animate-pulse"></div>
    } @else if (errored()) {
        <div
            class="
                w-full
                h-full
                flex
                items-center
                justify-around
            "
        >
            <div
                class="
                    flex
                    flex-col
                    items-center
                    gap-y-2
                "
            >
                <div
                    class="w-[80px] h-[80px] flex items-center justify-center"
                >
                    <div class="w-[54px] h-[54px] text-[54px]">
                        <mat-icon
                            svgIcon="app:empty_box"
                            inline
                            data-testid="iq-ntl-graph-multi-errored-icon"
                        ></mat-icon>
                    </div>
                </div>
                <div
                    class="
                        text-xs
                        text-dat-grey-500
                        text-center
                    "
                >
                    <div class="font-semibold" data-testid="iq-ntl-graph-multi-errored-title">National Rates Graph is currently unavailable.</div>
                    <div class="font-normal" data-testid="iq-ntl-graph-multi-errored-content">Refresh or try again later.</div>
                </div>
            </div>
        </div>
    }
    <div
        id="iq-ntl-graph-multi"
        class="w-full h-full"
        [ngClass]="{
            'opacity-0': loading() || errored()
        }"
        data-testid="iq-ntl-graph-multi-graph"
        #graph
    >
    </div>
</div>
